<button
  class="select-btn"
  role="button"
  (click)="handleClick()"
  [ngClass]="{ selected }"
>
  {{ text }}
</button>
